var _rect, _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRw(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 24,
    viewBox: "0 0 33 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2760_17527)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2760_17527",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.48999,
    width: 32,
    height: 24,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2760_17527)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.48999 0V24H32.49V0H0.48999Z",
    fill: "#FFCC00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2760_17527",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.48999 0V24H32.49V0H0.48999Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2760_17527)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.48999 0V14H32.49V0H0.48999Z",
    fill: "#3AA4D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.48999 18V24H32.49V18H0.48999Z",
    fill: "#5A972B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5718 11.8656C24.5386 11.8664 24.5054 11.8668 24.472 11.8668C24.4435 11.8668 24.415 11.8665 24.3866 11.8659L23.7821 13.8398L23.6543 11.7838C23.593 11.7712 23.5323 11.7571 23.4721 11.7418L22.4254 13.5217L22.7798 11.495C22.7228 11.4685 22.6664 11.4407 22.6109 11.4116L21.1794 12.9027L21.9957 11.0139C21.946 10.9749 21.8973 10.9347 21.8495 10.8934L20.1113 12.0162L21.3438 10.3675C21.3041 10.3177 21.2655 10.2669 21.2281 10.2152L19.2787 10.9099L20.8591 9.58953C20.8317 9.53135 20.8058 9.47239 20.7812 9.4127L18.7265 9.64357L20.5697 8.72045C20.5567 8.65722 20.5453 8.59345 20.5354 8.52916L18.4844 8.28534L20.492 7.80786C20.4941 7.74254 20.4978 7.67762 20.503 7.61315L18.5654 6.9085L20.6284 6.90187C20.6457 6.83861 20.6646 6.77598 20.6851 6.71403L18.9653 5.58727L20.9745 6.05147C21.0062 5.99415 21.0393 5.93769 21.0737 5.88214L19.6625 4.39286L21.5108 5.30363C21.5547 5.25539 21.5998 5.20823 21.6461 5.1622L20.6193 3.38969L22.2064 4.69831C22.2601 4.66153 22.3148 4.62602 22.3704 4.59182L21.7842 2.63182L23.0241 4.26812C23.0847 4.24476 23.1459 4.22282 23.2079 4.20234L23.0944 2.16011L23.9204 4.03744C23.9841 4.02871 24.0484 4.02147 24.1131 4.01576L24.4792 2L24.8456 4.01709C24.91 4.023 24.9739 4.03042 25.0373 4.03932L25.8641 2.16011L25.7503 4.20705C25.8113 4.22744 25.8715 4.24925 25.9311 4.27244L27.1743 2.63182L26.5858 4.59934C26.64 4.63289 26.6932 4.6677 26.7456 4.70371L28.3392 3.38969L27.3071 5.17132C27.3517 5.21602 27.3953 5.26177 27.4377 5.30854L29.296 4.39286L27.8761 5.89135C27.909 5.94488 27.9408 5.99925 27.9712 6.05442L29.9931 5.58727L28.2616 6.7218C28.281 6.7812 28.2991 6.84122 28.3157 6.90182L30.393 6.9085L28.4415 7.61824C28.4464 7.6799 28.4499 7.74197 28.4519 7.8044L30.4741 8.28534L28.4084 8.53091C28.3989 8.59239 28.388 8.65339 28.3757 8.7139L30.232 9.64357L28.1635 9.41115C28.14 9.46841 28.1151 9.525 28.089 9.58088L29.6797 10.9099L27.7189 10.2111C27.6829 10.261 27.6459 10.31 27.6077 10.3581L28.8471 12.0162L27.1007 10.888C27.0544 10.9282 27.0072 10.9674 26.9591 11.0055L27.7791 12.9027L26.3427 11.4066C26.2884 11.4352 26.2334 11.4626 26.1776 11.4888L26.5331 13.5217L25.4845 11.7385C25.425 11.7539 25.3649 11.768 25.3044 11.7807L25.1764 13.8398L24.5718 11.8656ZM24.436 10.4148C25.8366 10.4148 26.972 9.29593 26.972 7.91569C26.972 6.53545 25.8366 5.41654 24.436 5.41654C23.0354 5.41654 21.9 6.53545 21.9 7.91569C21.9 9.29593 23.0354 10.4148 24.436 10.4148ZM25.8946 7.98885C25.8946 8.77819 25.2548 9.41808 24.4654 9.41808C23.6761 9.41808 23.0362 8.77819 23.0362 7.98885C23.0362 7.1995 23.6761 6.55962 24.4654 6.55962C25.2548 6.55962 25.8946 7.1995 25.8946 7.98885Z",
    fill: "#FFDD1A"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2760_17527"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.48999,
    width: 32,
    height: 24,
    rx: 2,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRw);
export default __webpack_public_path__ + "static/media/RW.9a9bc15464ad4712fcfc9657e03fbc34.svg";
export { ForwardRef as ReactComponent };